<template>
  <div class="ma-15">
    <base-button
      :title="this.$t('app.tasks.create_task')"
      classNames="btn btn-orange btn-sm btn-block button-rounded"
      @clicked="$emit('clickCreateTask')"
    />
    <ul class="inbox-nav mb-40 mt-40">
      <li v-for="(item, index) in items" :key="index" :class="{selected: isSelected(index)}">
        <a @click="itemSelected(item,index)">{{item.title}}</a>
      </li>
    </ul>
    <base-button
      v-if="this.loggedInUser.role === 'vivu'"
      :forTasks="true"
      :title="!calendarView ? this.$t('app.tasks.calendarView') : this.$t('app.tasks.listView')"
      classNames="btn btn-orange btn-sm btn-block button-rounded"
      @clicked="$emit('navigateToCalendar')"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GenericForm from "@/components/shared/forms/GenericForm";
import BaseButton from "@/components/shared/buttons/BaseButton";

export default {
  name: "TasksInboxList",
  components: {
    "base-button": BaseButton
  },
  props: {
    calendarView: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      currentItemIndex: 0,
      items: [
        { title: "Saját intézkedések", filter: "own" },
        { title: "Elvégzett intézkedések", filter: "done" },
        { title: "Delegált intézkedések", filter: "delegated" },
        { title: "Törölt intézkedések", filter: "deleted" }
      ]
    };
  },
  created() {},
  computed: {
    ...mapGetters({
      loggedInUser: "loggedInUser",
    })
  },
  methods: {
    isSelected(index) {
      return index === this.currentItemIndex;
    },
    itemSelected(item, index) {
      this.currentItemIndex = index;
      this.$emit("filterChanged", item.filter);
    }
  }
};
</script>

<style lang="scss">
.inbox-nav {
  cursor: pointer;
  .selected {
    a {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/tasks/TasksInboxList.vue